import { LoginService } from './login';
import { SidebarService } from './sidebar';
import { LocalStorageService } from './local-storage/local-storage.service';
import {
  TokenSessionService,
  XprtSessionService,
  PermissionService,
} from './session';
import { DmDataService } from './dm-data';
import { XprtDataService } from './xprt-data';
import { StateService } from './state-service/state.service';
import { ExpiringStorageService } from './expiring-storage';
import { PostMessageService } from './post-message';
import { ToolsService } from './tools/tools.service';
import { QohService } from './qoh/qoh.service';
import { ModalLoaderService } from '@shared/services/modal-loader';
import { WindowWrapperService } from './window-wrapper';
import { CountryFormatService } from './country-format';
import { ListViewService } from './list-view';
import { CompanyUtilService } from './company';
import { NumberFormatService } from './number-format';
import { PdfBaseService } from '../common/make-pdf';
import { StandWorksheetPrintPdfService } from './stand-worksheet/stand-worksheet-print-pdf.service';
import { TransferPdfService } from './transfer/transfer.pdf.service';
import { AgGridService } from '@shared/services/ag-grid';
import { OrderPdfService } from './orders/order.pdf.service';
import { PdfGenerateServiceV2 } from '../common/make-pdf/v2/pdf.generate.service';
import { HttpErrorService } from './http-error';
import { ReallyChangeDetectService } from './really-change-detect';
import { StandWorksheetStatusChangeService } from './stand-worksheet/stand-worksheet-status-change.service';
import { CsvGenerateService } from '../common/export-csv/csv.generate.service';
import { TransferCsvService } from './transfer/transfer.csv.service';
import { TransferBaseFormService } from './transfer-common';
import { TaskService } from './task/task.service';
import { StaffDataService } from './staff-data';
import { TinyDuringTransferFormService } from './tiny-transfer/tiny-during-transfer-form.service';
import { TransferBulkStatusService } from './transfer-bulk/transfer-bulk-status.service';
import { InventoryCountPdfService } from './inventory-count/inventory-count-pdf.service';
import { OperatorService } from './operator/operator.service';
import { TransferQtyService } from './transfer-common/transfer-qty.service';
import { ReplenishWorkerBuilder } from './replenish-worker/replenish-worker.builder';
import { AutoPopulateService } from './auto-populate/auto-populate.service';
import { ScanningService } from './scanning/scanning.service';
import { TranslationService } from './translate/translation.service';
import { TranslationLoaderService } from './loaders/translation-loaders.service';
import { XuxDndCacheService } from './xux-dnd-cache/xux-dnd-cache.service';
import { BohDataService } from './boh-data/boh-data.service';
import { HawkerProfileColumnService } from './hawker-profile/hawker-profile.column.service';
import { HawkerSessionExtraDataService } from './hawker-session/hawker-session-extra-data.service';
import { XviCommissionRateService } from './xvi-commission-rate';
import { HawkerSessionCloseOutService } from './hawker-session/hawker-session-close-out.service';

export const UTILITY_SERVICES: any[] = [
  AgGridService,
  QohService,
  ListViewService,
  DmDataService,
  XprtDataService,
  XprtSessionService,
  PermissionService,
  LocalStorageService,
  TokenSessionService,
  CountryFormatService,
  LoginService,
  SidebarService,
  StateService,
  ExpiringStorageService,
  ModalLoaderService,
  PostMessageService,
  ToolsService,
  WindowWrapperService,
  CompanyUtilService,
  NumberFormatService,
  PdfBaseService,
  PdfGenerateServiceV2,
  StandWorksheetPrintPdfService,
  TransferPdfService,
  OrderPdfService,
  HttpErrorService,
  ReallyChangeDetectService,
  StandWorksheetStatusChangeService,
  CsvGenerateService,
  TransferCsvService,
  TransferBaseFormService,
  TaskService,
  StaffDataService,
  TinyDuringTransferFormService,
  TransferBulkStatusService,
  InventoryCountPdfService,
  OperatorService,
  TransferQtyService,
  ReplenishWorkerBuilder,
  AutoPopulateService,
  ScanningService,
  TranslationService,
  TranslationLoaderService,
  XuxDndCacheService,
  BohDataService,
  HawkerProfileColumnService,
  XviCommissionRateService,
  HawkerSessionExtraDataService,
  HawkerSessionCloseOutService,
];
